import { helpers } from 'vuelidate/lib/validators'
import extraConstants from '@/helpers/form-validators.js'
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

const validPhoneGoogleLib = (countryCode) => helpers.withParams(
  { type: 'validPhoneGoogleLib', value: countryCode },
  (value) => {
    if (value.length === 0) {
      return true
    }
    if (countryCode.code === '') {
      return false
    }
    try {
      var newphone = phoneUtil.parse(value)
      var isValid = phoneUtil.isValidNumber(newphone, countryCode.code)
    } catch (e) {
      return false
    }
    return isValid
  })

const singlePhoneGoogleLib = (countryCode) => helpers.withParams(
  { type: 'singlePhoneGoogleLib', value: countryCode },
  (value) => {
    if (value.length === 0) {
      return true
    }
    if (countryCode.code === '') {
      return false
    }
    var fullPhone = '+' + countryCode.code + '.' + value
    try {
      var newphone = phoneUtil.parse(fullPhone)
      var isValid = phoneUtil.isValidNumber(newphone, countryCode.code)
    } catch (e) {
      return false
    }
    return isValid
  })

const optionalEmail = helpers.withParams(
  { type: 'optionalEmail' },
  (value) => {
    if (value.length === 0) {
      return true
    }
    var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/

    if (emailRegex.test(value)) {
      return true
    }
    return false
  })

const minLenghtOptional = (limit) => helpers.withParams(
  { type: 'minLenghtOptional', min: limit },
  (value) => {
    if (value.length === 0) {
      return true
    }
    if (value.length > limit) {
      return true
    }
    return false
  })

const singlePhone = (limit) => helpers.withParams(
  { type: 'singlePhone', min: limit },
  (value) => {
    if (value.length === 0) {
      return true
    }
    if (value.length < limit) {
      return false
    }
    return true
  })

const checkInternationalCode = helpers.withParams(
  { type: 'checkInternationalCode' },
  (value) => {
    if (value.code.length > 0) {
      return true
    }
    return false
  })

const optionalUrl = helpers.withParams(
  { type: 'optionalUrl' },
  (value) => {
    if (value.length === 0) {
      return true
    }
    const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i
    if (urlRegex.test(value)) {
      return true
    }
    return false
  })

const validPhone = helpers.withParams(
  { type: 'validPhone' },
  (value) => {
    if (value.length === 0) {
      return true
    }
    const regNumber = /^\+(?=.{12,16}$)[1-9]\d{0,2}\.\d+$/
    if (regNumber.test(value)) {
      return true
    }
    return false
  })

const validCountry = helpers.withParams(
  { type: 'validCountry' },
  (value) => extraConstants.COUNTRYCODES.includes(value) === true
)

const validState = (isUsa) => helpers.withParams(
  { type: 'validState', value: isUsa },
  (value) => {
    if (isUsa) {
      if (value.length > 0) {
        return true
      }
      return false
    }
    return true
  }
)

const validProvince = (isUsa) => helpers.withParams(
  { type: 'validProvince', value: isUsa },
  (value) => {
    if (!isUsa) {
      if (value.length > 0) {
        return true
      }
      return false
    }
    return true
  }
)

const domainNameValidation = helpers.regex('domainNameValidation', /^[a-zA-Z0-9][a-zA-Z0-9-]{0,63}[a-zA-Z0-9]?(\.[a-zA-Z0-9][a-zA-Z0-9-]{0,63}[a-zA-Z0-9]?)*$/)

export {
  optionalEmail,
  minLenghtOptional,
  singlePhone,
  checkInternationalCode,
  optionalUrl,
  validPhone,
  validCountry,
  validState,
  validProvince,
  domainNameValidation,
  validPhoneGoogleLib,
  singlePhoneGoogleLib
}
